<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!resellerService">
      <span class="loader"></span>
    </span>
    <div v-if="resellerService" class="elite-tabs-wrapper">
      <tabs
        fill
        class="flex-column flex-md-row"
        tabNavWrapperClasses="nav-wrapper"
        tabNavClasses="nav elite-tabs"
        value="global"
      >
        <tab-pane title="global" id="1" :active="true">
          <span slot="title">
            <i class="ni ni-cloud-upload-96" />
            {{ $t("COMMON.GLOBAL") }}
          </span>
          <reseller-service-view-global :resellerService="resellerService" />
        </tab-pane>

        <tab-pane title="gallery" id="2">
          <span slot="title">
            <i class="ni ni-cloud-upload-96" />
            {{ $t("COMMON.GALLERY") }}
          </span>
          <reseller-service-view-gallery :resellerService="resellerService" />
        </tab-pane>

        <tab-pane
          title="logs"
          id="999"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
        >
          <span slot="title">
            <i class="fa fa-file" />
            {{ $t("COMMON.LOGS") }}
          </span>
          <resellerService-view-logs :resellerService="resellerService" />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import ResellerServiceViewGlobal from "../partials/ResellerServiceViewGlobal.vue";
import ResellerServiceViewLogs from "../partials/ResellerServiceViewLogs.vue";
import ResellerServiceViewGallery from "../partials/ResellerServiceViewGallery.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    ResellerServiceViewGlobal,
    ResellerServiceViewGallery,
    ResellerServiceViewLogs,
  },

  mixins: [requestErrorMixin],

  props: {
    resellerServiceId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      resellerService: null,
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch(
          "resellerServices/get",
          this.resellerServiceId
        );
        this.resellerService =
          this.$store.getters["resellerServices/resellerService"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
